
import { jsPDF } from "jspdf";
import { PdfResourcesOptions } from "../types";

/**
 * Add resources section
 */
export const addResources = (doc: jsPDF, { startY, pageWidth, colors }: PdfResourcesOptions): void => {
  // Add a new page for resources
  doc.addPage();
  
  // Resources header - using techne-primaryPurple
  doc.setFillColor(colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125);
  doc.rect(0, 0, pageWidth, 30, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text("Additional Resources", pageWidth / 2, 20, { align: "center" });
  
  // Resources content
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.text("Recommended Resources for Board AI Governance", 15, 45);
  
  doc.setDrawColor(colors?.purple[0] || 189, colors?.purple[1] || 71, colors?.purple[2] || 230);
  doc.setLineWidth(0.8);
  doc.line(15, 50, pageWidth - 15, 50);
  
  const resources = [
    {
      title: "AI Governance Framework for Boards",
      description: "A comprehensive guide to establishing AI governance structures at the board level.",
    },
    {
      title: "AI Risk Assessment Toolkit",
      description: "Tools and templates for identifying and mitigating AI-related risks.",
    },
    {
      title: "Board-level AI Education Program",
      description: "Educational resources to build AI literacy among board members.",
    },
    {
      title: "AI Ethics Guidelines",
      description: "Industry-standard ethical principles for responsible AI implementation.",
    },
    {
      title: "AI Vendor Due Diligence Guide",
      description: "A framework for evaluating third-party AI providers.",
    },
  ];
  
  // Increase spacing between resources
  let resourceY = 65;
  resources.forEach((resource) => {
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125);
    doc.text(resource.title, 20, resourceY);
    
    doc.setFont(undefined, 'normal');
    doc.setTextColor(0, 0, 0);
    const descLines = doc.splitTextToSize(resource.description, pageWidth - 40);
    doc.text(descLines, 20, resourceY + 10);
    
    resourceY += 10 + (descLines.length * 7) + 20; // Increased spacing between resources
  });
};

